import NavigationMobile from './navigation-mobile';
import SearchOverlay from './search-overlay';
import Header from './header';
import Slideshow from './slideshow';
import Parallax from './parallax';
import Carousel from './carousel';
import CarouselSO from './carousel-so';
import SliderGallery from './slider-gallery';
import SliderText from './slider-text';
// import lightGallery from 'lightgallery';
// import lgVideo from 'lightgallery/plugins/video';
// import lgZoom from 'lightgallery/plugins/zoom';
import toTop from './totop';
import AOS from 'aos';
import { gsap, Power4 } from 'gsap';
import * as ScrollToPlugin from "gsap/ScrollToPlugin";
import Plyr from 'plyr';

import textAppear from './text-appear';
import Preloader from './preloader';
import 'youtube-background';

gsap.registerPlugin(ScrollToPlugin);

require('intersection-observer');

let _root;
let _isStarted = false;
let _parallax;

class App {
    static start() {
        return new App()
    }

    constructor() {
        _root = this;

       /*  const tl = new gsap.timeline();
        const mask = document.querySelector('#mask');
        const mask_inner_1 = mask.querySelector('.mask-inner-1');
        const mask_inner_2 = mask.querySelector('.mask-inner-2');
        const mask_inner_3 = mask.querySelector('.mask-inner-3');

        const options = [
            {
              from: '(.*)',
              to: '(.*)',
              out: (done) => {
                const container = document.querySelector('#swup');
                tl.set([container], { y: 0 });
                

                tl.set([mask], { display: 'block' });
                tl.set([mask_inner_1, mask_inner_2, mask_inner_3], {
                    display: 'block',
                    x: '100%',
                });

                tl.to([mask_inner_1, mask_inner_2, mask_inner_3], {
                    duration: 0.3,
                    x: '0%',
                    transformOrigin: 'left left',
                    ease: Power4.easeOut,
                    stagger: 0.1,
                    // onComplete: done
                });

                tl.to(container, { y: 100, duration: 0.5, ease: Power4.easeOut, onComplete: done });
              },
              in: (done) => {
                const container = document.querySelector('#swup');
                tl.set([container], { y: 100 });

                tl.to([mask_inner_1, mask_inner_2, mask_inner_3], {
                    duration: 0.3,
                    x: '-100%',
                    transformOrigin: 'left left',
                    ease: Power4.easeIn,
                    stagger: 0.1,
                    // onComplete: done
                });

                tl.to(container, { y: 0, duration: 0.5, ease: Power4.easeOut, onComplete: done });
              }
            }
        ]; */

        new Preloader();

        

       /*  const swup = new Swup({
            plugins: [
                new SwupProgressPlugin(),
                new SwupJsPlugin(options),
                //new SwupFormsPlugin()
            ]
        });
        
        swup.hooks.on('content:replace', _root.init);

        swup.hooks.on('page:view', () => {
          setTimeout(() => {
            _parallax.startMoveElements();
            Drupal.attachBehaviors();
          }, 500);
        }, { once: false }); */

        document.addEventListener("DOMContentLoaded", () => {
            
            _root.init();
            _isStarted = true;
        });

    }

    init() {
      _root.startIntersectionObserver();
      new Header();
      new NavigationMobile();
      new SearchOverlay();
      new Slideshow();
      new Carousel();
      new CarouselSO();
      new SliderGallery();
      new SliderText();
      new toTop();

      Array.from(document.querySelectorAll('.plyr__video-embed')).map((p) => new Plyr(p));

      _parallax = new Parallax();

      

      // lightGallery(document.getElementById('project-video-gallery__inner'), {
      //     plugins: [lgZoom, lgVideo],
      //     // licenseKey: '0000-0000-000-0000',
      //     selector: '.project-main-video',
      //     speed: 500,
      //     youTubePlayerParams: {
      //         modestbranding : 1,
      //         showinfo : 0,
      //         rel: 0,
      //         controls : 0
      //     },
      //     loadYoutubeThumbnail: true,
      //     youtubeThumbSize: 'default',
      //     autoplayVideoOnSlide : true,
      //     videojs: true

      // });

      if (jQuery('[data-vbg]').length != 0) {
          jQuery(document).ready(function() {
            jQuery('[data-vbg]').youtube_background();
        });
      }

      const textappear = new textAppear();

      AOS.init();

      if ( _isStarted) {
        textappear.init();
      }

      const element = document.querySelectorAll('.scroll-page-link');

        if ('undefined' != typeof element && null != element) {
            element.forEach(function(item) {
                _root.addEvent(item, 'click', _root.onClickScrollPageEvent);
            });
        }
      
    }

    startIntersectionObserver() {
      const observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 0.3,
      };
      const observer = new IntersectionObserver(_root.observerCallback, observerOptions);

      document.querySelectorAll('.increment-number').forEach((el) => observer.observe(el));

  }

    observerCallback(entries) {

        entries.forEach((entry) => {
            if (entry.isIntersecting) {

              if ( entry.target.classList.contains('increment-number') ) {

                let matches = entry.target.dataset.number.match(/(\d+)/);
                
                let zero = { val:0 };
                let num = 0;

                if (matches) {
                  num = matches[0];
                }

                gsap.to(zero, { val: num, duration: 2, ease:"none", onUpdate:function() {
                    const numberFormatter = Intl.NumberFormat('it-IT');

                    if ( !isNaN( zero.val )  ) {

                      entry.target.querySelector('span').innerHTML = numberFormatter.format(( zero.val).toFixed() );
                    }
                } } );
              }

            }
        });
    }

    onClickScrollPageEvent(el) {
      
      const _link = el.currentTarget.getAttribute('href');
        const _anchor = document.querySelector(_link);
        let scrollTop = 0;

        if ('undefined' != typeof _anchor && null != _anchor) {
            scrollTop = _anchor.getBoundingClientRect().top + window.scrollY;

        }

        gsap.to(window, {
            duration: 0,
            scrollTo: { y: scrollTop },
            ease: Power4.easeOut
        });

        el.preventDefault();
        el.stopImmediatePropagation();

    }

    addEvent(el, type, handler) {
      if (el.attachEvent) el.attachEvent('on' + type, handler);
      else el.addEventListener(type, handler);
    }

    removeEvent(el, type, handler) {
        if (el.detachEvent) el.detachEvent('on' + type, handler);
        else el.removeEventListener(type, handler);
    }

}

App.start();


/* 
(($, Drupal) => {

  Drupal.behaviors.myBehaviors = {
    attach: function (context, settings) {

      // if ($('#video-home-holder').length != 0) {
      //   $("#video-home-params").YTPlayer({
      //         useNoCookie: true,
      //         playOnlyIfVisible: true
      //     });
      // }

    }
  }

})(jQuery, Drupal);
 */